export class CareerMetaModel {
    constructor(
        public is_active: boolean,
        public published_at: string,
        public created_at: string,
        public updated_at: string
    ) {}
}